module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"ProductReviewBox":{"anonymous":"Ověřený zákazník","averageReviewText":"Hodnocení {averageRating} z {starsCount}","logo":{"heureka":{"title":"Recenze z Heureka.cz"}},"noText":"Škoda, zákazník neuvedl slovní hodnocení.","reply":{"label":{"desktop":"Odpověď e-shopu","mobile":"Odpověděl(a)"}}}}}')
  delete Component.options._Ctor
}
